var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.users.length == 0 && _vm.item.watchers.length == 0)?_c('div',[_c('v-btn',{attrs:{"fab":"","dark":"","x-small":"","color":"red"},on:{"click":_vm.removeTask}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-delete ")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }